import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils/logger';
import { errorMessage } from './constants';

const purchaseVariation = async ({ projectId, sourceVariationId, brandName, roots, log, context }) => {
    const requestUrl = pathfinder('logo_maker_seller_editor_ajax', { endpoint: 'purchase_buyer_variation' });

    try {
        const { data } = await axios.post(requestUrl, {
            projectId,
            sourceVariationId,
            brandName,
            roots,
            log,
            context,
        });

        if (data.error) {
            throw new Error(data.error);
        }

        return data.variationId;
    } catch (e) {
        logAPIError(e, { message: errorMessage, projectId, sourceVariationId, ...context });

        throw new Error(errorMessage);
    }
};

export default purchaseVariation;
